import Hero from "./Hero";
import Container from "./ui/Container";
import SectionHeader from "./ui/SectionHeader";
import { PrimaryButton } from "./ui/Buttons";
import licLogo from "../assets/lic-logo.png";
import starHealthLogo from "../assets/star-health-logo.png";
import hfclLogo from "../assets/lic-hfcl-logo.png";

export default function Insurance() {
    const insurances = [
        {
          type: "Life Insurance (LIC)",
          desc: "Secure your family's future with trusted LIC plans tailored to your needs.",
        },
        {
            type: "LIC HFCL",
            desc: "Specialized financial and insurance solutions offered by LIC HFCL.",
        },
        {
          type: "Health Insurance (Star Health)",
          desc: "Protect yourself and your loved ones from unexpected medical expenses with Star Health policies.",
        },
      ];

    const features = [
        "Customized plans for individuals & families",
        "Trusted LIC and Star Health products",
        "Flexible premium options",
        "Hassle-free claim process",
        "Expert guidance from our agents",
    ];

    const partners = [
        {
            name: "LIC",
            logo: licLogo,
            description: "Leading life insurance provider in India with comprehensive plans.",
            url: "https://licindia.in",
        },
        {
            name: "LIC HFCL",
            logo: hfclLogo,
            description: "Financial and insurance services provided by LIC HFCL.",
            url: "https://lichousing.com",
        },
        {
            name: "Star Health & Allied Insurance",
            logo: starHealthLogo,
            description: "Specialized health insurance plans with extensive coverage options.",
            url: "https://starhealth.in",
        },
    ];

    return (
        <>
            <Hero />

            {/* Intro Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <SectionHeader
                        title="Insurance Services"
                        subtitle="Comprehensive LIC & Star Health Plans"
                    />
                    <p className="mt-4 text-gray-700 max-w-3xl">
                        We provide secure LIC life insurance and Star Health policies tailored for individuals and families.
                        Our goal is to ensure financial protection and peace of mind for you and your loved ones.
                    </p>
                </Container>
            </section>

            {/* Insurance Cards */}
            <section className="py-8 bg-gray-50">
                <Container>
                    <div className="grid md:grid-cols-2 gap-6">
                        {insurances.map((item, i) => (
                            <div key={i} className="p-6 bg-white shadow rounded-lg">
                                <h3 className="text-xl font-bold text-blue-600">{item.type}</h3>
                                <p className="mt-2 text-gray-600">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* Features Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Why Choose Our Insurance?</h2>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                        {features.map((f, i) => (
                            <li key={i}>{f}</li>
                        ))}
                    </ul>
                </Container>
            </section>

            {/* Our Partners Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <h2 className="text-2xl font-bold mb-8">Our Partners</h2>
                    <div className="grid md:grid-cols-2 gap-6">
                        {partners.map((p, i) => (
                            <a
                                key={i}
                                href={p.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-6 bg-white shadow rounded-lg flex flex-col items-center text-center hover:shadow-md transition cursor-pointer"
                            >
                                <img src={p.logo} alt={p.name} className="h-16 mb-4 object-contain" />
                                <h3 className="text-xl font-bold mb-2">{p.name}</h3>
                                <p className="text-gray-600">{p.description}</p>
                            </a>
                        ))}
                    </div>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="py-16 bg-blue-50">
                <Container className="text-center">
                    <h2 className="text-2xl font-bold mb-4">Get Your Insurance Today</h2>
                    <p className="text-gray-700 mb-6">
                        Contact us to choose the best insurance plan that fits your lifestyle and needs.
                    </p>
                    <PrimaryButton onClick={() => window.location.href = "/contact"}>
                        Contact Us
                    </PrimaryButton>
                </Container>
            </section>
        </>
    );
}
